import { useState } from 'react'
import { useGetQuery, usePostQuery } from 'hooks'
import { Button, Card, Table } from 'components'

const STATUS_LABEL = { pending: 'Pending', invited: 'Invited', used: 'Signed Up' }

const setRow = (setter, id, val) => setter((prev) => ({ ...prev, [id]: val }))

export const AdminBetaSignups = () => {
  const { data, refetch } = useGetQuery({ url: '/admin/beta_signups' })
  const { post: sendInvitePost } = usePostQuery({})
  const { post: cancelInvitePost } = usePostQuery({ method: 'DELETE' })
  const [rowState, setRowState] = useState({})
  const rows = data?.beta_signups || []

  const sendInvite = (id) => {
    setRow(setRowState, id, 'sending')
    sendInvitePost({}, `/admin/beta_signups/${id}/invite`)
      .then((res) => {
        if (res?.beta_signup) {
          setRow(setRowState, id, 'sent')
          refetch(true)
        } else {
          setRow(setRowState, id, 'error')
        }
      })
      .catch(() => setRow(setRowState, id, 'error'))
  }

  const cancelInvite = (id) => {
    setRow(setRowState, id, 'cancelling')
    cancelInvitePost({}, `/admin/beta_signups/${id}/invite`)
      .then((res) => {
        if (res?.beta_signup) {
          setRow(setRowState, id, null)
          refetch(true)
        } else {
          setRow(setRowState, id, 'error')
        }
      })
      .catch(() => setRow(setRowState, id, 'error'))
  }

  return (
    <Card>
      <Table
        data={rows}
        columns={[
          { title: 'Email', key: 'email' },
          {
            title: 'Business',
            key: 'signup_type',
            render: (type, _i, row) =>
              type === 'host' ? (row.Location?.name || 'new business') : '—',
          },
          {
            title: 'Status',
            key: 'status',
            render: (status) => STATUS_LABEL[status] || status,
          },
          {
            title: 'Invited',
            key: 'invited_at',
            render: (v) => v ? new Date(v).toLocaleDateString() : '—',
          },
          {
            title: 'Used',
            key: 'used_at',
            render: (v) => v ? new Date(v).toLocaleDateString() : '—',
          },
          {
            title: 'Action',
            key: 'id',
            className: 'right',
            render: (id, _i, row) => {
              const s = rowState[id]
              if (row.status === 'used') return null
              if (row.status === 'invited') {
                return (
                  <span style={{ display: 'flex', gap: '0.4rem', justifyContent: 'flex-end' }}>
                    <Button
                      disabled={s === 'sending' || s === 'cancelling'}
                      onPress={() => sendInvite(id)}
                    >
                      {s === 'sending' ? 'Sending…' : s === 'sent' ? 'Resent ✓' : s === 'error' ? 'Failed — retry' : 'Resend'}
                    </Button>
                    <Button
                      disabled={s === 'cancelling' || s === 'sending'}
                      onPress={() => cancelInvite(id)}
                    >
                      {s === 'cancelling' ? 'Cancelling…' : 'Cancel'}
                    </Button>
                  </span>
                )
              }
              return (
                <Button
                  disabled={s === 'sending'}
                  onPress={() => sendInvite(id)}
                >
                  {s === 'sending' ? 'Sending…' : s === 'sent' ? 'Sent ✓' : s === 'error' ? 'Failed — retry' : 'Send Invite'}
                </Button>
              )
            },
          },
        ]}
      />
    </Card>
  )
}
